import backofficeService from '../../api/backoffice'

export default {
  /**
   *  Get token from server
   * @param {} id
   * @param {*} pin
   * @param {*} locationCode
   * @param {*} deviceCode
   * @param {*} deviceName
   */
  authenticate(params) {
    return backofficeService.Api().post('crmApiToken', {
        username: 'cellsmartpos',
        password: 'GxntdzwfXwuLXtAwTBEn2@YwrcRAiReT',
        loginEmail: params.loginEmail,
        loginPassword: params.loginPassword,
      })
      .then((response) => {
        console.log('response authenticate', response)
        localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`, response.data.token)
        // localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`, response.data.token.organization.organizationID)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Remove the location code store if there exist one/
   */
  resetOrganization() {
    return localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
  },
  Google: {
    getToken(data = {}) {
      data.username = 'cellsmartpos'
      data.password = 'GxntdzwfXwuLXtAwTBEn2@YwrcRAiReT'
      return backofficeService.Api().post('auth/google/token', data)
        .then((response) => {
          console.log('google token', response)
          localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`, response.data.token)
          return response.data
        })
        .catch((error) => {
          throw error
        })
    },
  },
}
